import React from 'react'
import { GlobalContext, UserContext } from 'components/context'

const lastPin = (keys) => {
  if (!keys) return

  const pins = keys.filter(k => k.type === 'pin')
  if (pins.length < 1) return
  if (pins.length === 1) return pins[0]

  // There might be more than one PIN, so
  // we find the one that was activated last
  return pins.reduce((a, b) => a.valid_from > b.valid_from ? a : b)
}

// Pin details for operators with nfc enabled
const Pin = () => {
  const { t } = React.useContext(GlobalContext)
  const { membership } = React.useContext(UserContext)

  if (!membership) return null

  const pin = lastPin(membership.keys)
  const pinActive = pin && pin.status === 'active'

  return (
    <div className={'index-info full-width'}>
      <h2>{ t('pages.pin.title') }</h2>
      <div className={ pinActive ? 'code' : 'code-inactive'}>{pin && pin.code}</div>
      <div className={ pinActive ? 'invisible' : 'expiry-label'}>Expired</div>
    </div>
  )
}

export default Pin
